export default "__VITE_ASSET__D6nP_MPl__"